import CommentsEmpty from './CommentsEmpty'

export default CommentsEmpty
// eslint-disable-next-line import/export
export * from './CommentsEmpty'
